import React from 'react';

import { BadgeLoadingProps, BadgeProps } from './types';
import { Container, Icon, Text } from '@/ui/Label/atoms';
import { IconVariant } from '@/ui/Label/atoms/Icon/types';
import { useLabelState } from './hooks';
import { TextVariant } from '@/ui/Label/atoms/Text/types';
import { Skeleton } from '@/ui/Skeleton';
import { makeNamespacedComponent } from '@/ui/utils';

const BadgeLabelBase = ({ text, badgeVariant, className, noIcon }: BadgeProps): JSX.Element => {
  const { icon, backgroundColor } = useLabelState(badgeVariant);
  const isTextRequired = badgeVariant !== 'badge-dot';

  return (
    <Container variant={badgeVariant || 'badge-text'} backgroundColor={backgroundColor} className={className}>
      {icon && !noIcon && <Icon variant={badgeVariant as IconVariant} icon={icon} />}
      {text && isTextRequired && <Text variant={(badgeVariant || 'badge-text') as TextVariant} content={text} />}
    </Container>
  );
};

const LoadingState = ({ badgeVariant, overrideWidth }: BadgeLoadingProps): JSX.Element => {
  const { skeletonWidth, skeletonHeight } = useLabelState(badgeVariant);

  return (
    <Container variant={badgeVariant || 'badge-text'}>
      <Skeleton height={skeletonHeight} width={overrideWidth ?? skeletonWidth} />
    </Container>
  );
};

const BadgeLabel = makeNamespacedComponent(BadgeLabelBase, {
  LoadingState,
});

export { BadgeLabel };
